import { Zipcode } from '../../../constants/AppConstants';
import { getValue } from '@chegg/commerce-utils';
export var getAddressFromEditableMop = function getAddressFromEditableMop(editableMop) {
  // else load data from selctedMOP
  // for editable mop, if zipcode is 11111 hide this value from user
  var currentZipcode = getValue(editableMop, 'billingAddress.zip', '');
  var currentCity = getValue(editableMop, 'billingAddress.city', '');
  var currentState = getValue(editableMop, 'billingAddress.state', '');
  if (currentZipcode === Zipcode.ALL_ONES) {
    currentZipcode = '';
    currentCity = '';
    currentState = '';
  }
  return {
    line1: getValue(editableMop, 'billingAddress.line1', ''),
    line2: getValue(editableMop, 'billingAddress.line2', ''),
    city: currentCity,
    state: currentState,
    zipCode: currentZipcode,
    countryISO: getValue(editableMop, 'billingAddress.country', '')
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/UserAddress/utils/getAddressFromEditableMop.js
// module id = 4559
// module chunks = 11